import styled from '@emotion/styled';

const StyledHeaderWrapper = styled.div`
  padding: 15px 24px 15px 24px;
  gap: 0px;
  border: 0px 0px 1px 0px;
  justify: space-between;
  opacity: 0px;
  background: #0e0e12;
  border-bottom: 1px solid #ffffff1f;
`;

export { StyledHeaderWrapper };
